import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Form, FormCheck, FormGroup, Modal, Row } from 'react-bootstrap';
import { calculaDiffDatas, dateDbToBr, float2moeda } from '../../utils/Funcoes';
import { statusAgendamentosUtils } from '../../utils/statusAgendamentosUtils'
import { AgendamentosService } from '../../services/api/Agendamentos/AgendamentosService';
import './agenda.css'
import { faBan, faCircleXmark, faPencil, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PermissoesComponent from '../../components/PermissaoComponent';

import { tiposAgendamentosUtils } from '../../utils/tiposAgendamentosUtils'

const AgendaCadModalVer = ({ children, show, args, handleClose, handleConfirm, refreshAgendamentos,
    filtrosAgenda, dadosProfissional, listPermissoes, editEvent }) => {



    const [idAgendamento, setIdAgendamento] = useState(null)
    const [agendamento, setAgendamento] = useState(null)
    const [valorTotal, setValorTotal] = useState(0)
    const [naoAtende, setNaoAtende] = useState('')
    const [tipoAgendamento, setTipoAgendamento] = useState(null)
    useEffect(() => {

        //  console.log(args)
        const fetchAgendamento = async (id) => {

            const dados = await AgendamentosService.getById(id);
            let servicoId = dados.data?.agendamentoItens[0]?.servicosId
            let servicoValor = dados.data?.agendamentoItens[0]?.valorServico
            //console.log(dados)

            let dateInicio = dados.data.inicio.split(' ')
            let dataTermino = (dados.data?.termino != null) ? dados.data.termino.split(' ') : null;

            setTipoAgendamento(tiposAgendamentosUtils().find(tp => tp.id == dados.data?.tipoAgendamentoId))
            setAgendamento({
                ...dados.data,
                clientesId: dados.data?.clientes?.id,
                animaisId: dados.data?.animais?.id.toString(),
                dataInicio: dateInicio[0],
                horaInicio: dateInicio[1].substring(0, 5),
                servicosId: dados.data?.agendamentoItens[0]?.servicosId,
                servicosQnt: dados.data?.agendamentoItens[0]?.qnt,
                servicosValor: servicoValor,
                servicosAgendaItemId: dados.data?.agendamentoItens[0]?.id,
                dataTermino: (dataTermino != null) ? dataTermino[0] : null,
                horaTermino: (dataTermino != null) ? dataTermino[1].substring(0, 5) : null,
                status: dados.data.status,
                profissionaisId: dados.data?.profissionaisId,
                observacoes: dados.data?.observacoes,
                tiposServicosId: dados.data?.tiposServicosId,
                dadosStatus: statusAgendamentosUtils().find(item => item.id == dados.data.status)

            })

            /**if (dataTermino != null) {
                setShowTermino(true)
            }**/



        }





        if ((listPermissoes?.cadastrar && args?.id == null)
            || (listPermissoes?.editar && args?.id != null)
        ) {
            //console.log(filtrosAgenda)
            if (args != null) {
                if (args?.id != undefined) {
                    setIdAgendamento(args.id)
                    fetchAgendamento(args.id)
                }


            }
        }

        //    setShowTermino(false)
    }, [args])




 //   console.log(agendamento)
    //   console.log(optionsAnimais)
    return (

        <Modal show={show} onHide={() => handleClose()} size='lg'>
            <Modal.Body style={{ fontSize: '14px' }}>
                <h4 className="text-primary "> <span style={{ color: tipoAgendamento?.color }}>{tipoAgendamento?.nome} </span> </h4>
                <hr></hr>

                {(
                    (!listPermissoes?.cadastrar && args?.id == null)
                    || (!listPermissoes?.editar && args?.id != null)
                ) ? (<PermissoesComponent showMsg={true}>
                    <Modal.Footer className='justify-content-center'>
                        <Button variant='danger' size='sm' onClick={() => handleClose()}><FontAwesomeIcon icon={faCircleXmark} /> Fechar</Button>
                    </Modal.Footer>
                </PermissoesComponent>) : (
                    <>
                        {(naoAtende == '') ? (



                            <Form>
                                <div >
                                    {(agendamento?.tipoAgendamentoId == 1 && <>
                                        <Row>
                                            <Col md={6} xs={12} className='mb-15'>
                                                <h5 className=''>Dados do Cliente</h5>
                                                <FormGroup controlId='clienteId'>


                                                    <Form.Label>Cliente: </Form.Label>
                                                    <span className='ml-5'>{agendamento?.clientes?.nome}</span>

                                                </FormGroup>
                                                <FormGroup controlId='servicosId'>
                                                    <Form.Label>Serviço:</Form.Label>
                                                    <span className='ml-5'>
                                                        {(agendamento?.agendamentoItens.length > 0) ? agendamento?.animaisClientes[0]?.nome : 'Não informado'}
                                                    </span>

                                                </FormGroup>
                                            </Col>
                                            <Col md={6} xs={12} className='mb-15'>
                                                <h5 className=''>Dados do Animals</h5>
                                                <FormGroup as={Col} sm={6} controlId='animaisId'>
                                                    <Form.Label>Animal:</Form.Label>
                                                    <span className='ml-5'>
                                                        {(agendamento?.animaisClientes.length > 0) ? agendamento?.animaisClientes[0]?.nome : 'Não informado'}
                                                    </span>
                                                </FormGroup>
                                            </Col>



                                        </Row>
                                        <hr></hr>
                                    </>)}




                                    <Row >
                                        <Col className=''>
                                            {(tipoAgendamento?.id == 1 && <h5 className=''> Detalhes do Agendamento </h5>)}
                                            <Row>
                                                <Col>
                                                    <FormGroup  >

                                                        <Form.Label>Início:</Form.Label>
                                                        <span className='ml-5'>
                                                            {
                                                                (agendamento?.dataInicio) ?
                                                                    dateDbToBr(agendamento?.dataInicio) + ' às ' + agendamento?.horaInicio + 'h'
                                                                    : ''}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                                {(agendamento?.dataTermino != null) ?
                                                    (
                                                        <Col>
                                                            <FormGroup  >
                                                                <Form.Label>Término:</Form.Label>
                                                                <span className='ml-5'>
                                                                    {dateDbToBr(agendamento?.dataTermino) + ' às ' + agendamento?.horaTermino + 'h'
                                                                    }
                                                                </span>
                                                            </FormGroup>
                                                        </Col>
                                                    )
                                                    : ''}
                                            </Row>
                                            {(tipoAgendamento?.id == 1 &&
                                                <FormGroup controlId='status'>
                                                    <Form.Label>Status: </Form.Label>&nbsp;
                                                    {
                                                        agendamento?.dadosStatus?.nome
                                                    }
                                                </FormGroup>)}
                                        </Col>
                                    </Row>

                                    <Row className=''>
                                        <FormGroup controlId='observacoes' >
                                            <Form.Label>Observações:</Form.Label>&nbsp;
                                            {(agendamento?.observacoes != '' && agendamento?.observacoes)}
                                        </FormGroup>
                                    </Row>
                                </div>
                                <br></br>

                                <Modal.Footer className='justify-content-center'>
                                    {(tipoAgendamento?.id == 1 &&
                                        <Button variant='primary' size='xs' onClick={() => editEvent(args)}><FontAwesomeIcon icon={faPencil} /> Editar</Button>
                                    )}
                                    <Button variant='danger' size='xs' ><FontAwesomeIcon icon={faTrash} /> Excluir</Button>

                                    <Button variant='secondary' size='xs' onClick={() => handleClose()}><FontAwesomeIcon icon={faBan} /> Fechar</Button>

                                </Modal.Footer>
                            </Form>

                        ) : <div className='alert alert-danger'>{naoAtende}</div>}

                    </>)
                }
            </Modal.Body >

        </Modal >
    )
}


export default AgendaCadModalVer;